module.exports = __webpack_public_path__ + "img/add-box.ee70e75a.svg";